import styled from 'styled-components';
import { AddToList as MaterialAddToList } from '../../../../styles/icons';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const AddToList = styled(MaterialAddToList)`
  width: 25px;
  height: 25px;
  fill: var(--secondary);
`;
